import { useAuthService } from "~/composables/useAuthService";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const { isAuthenticated, user } = useAuthService();

    if (!isAuthenticated.value) {
        return; // Let the main auth middleware handle unauthenticated users
    }

    const missingName =
        !user.value.firstName?.trim() || !user.value.lastName?.trim();

    const isLoginCompletePage = to.path === "/details-required";

    if (missingName && !isLoginCompletePage) {
        return navigateTo("/details-required?redirectUrl=" + to.fullPath);
    }

    if (!missingName && isLoginCompletePage) {
        return navigateTo("/");
    }
});
